module.exports = "/_next/static/images/photoOxanaMagalu-9684f57829a98778350df2c32ab106d7.webp";